const C = {
  name: "ComplianceTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.4144 13L11.0002 18.4142L7.58594 15L9.00015 13.5858L11.0002 15.5858L15.0002 11.5858L16.4144 13Z" fill="currentColor"/>
<path d="M14.4142 0L21 6.58579V21C21 21.7957 20.6839 22.5587 20.1213 23.1213C19.5587 23.6839 18.7957 24 18 24H6C5.20435 24 4.44129 23.6839 3.87868 23.1213C3.31607 22.5587 3 21.7957 3 21V3C3 2.20435 3.31607 1.44129 3.87868 0.87868C4.44129 0.316071 5.20435 0 6 0H14.4142ZM6 2C5.73478 2 5.48043 2.10536 5.29289 2.29289C5.10536 2.48043 5 2.73478 5 3V21C5 21.2652 5.10536 21.5196 5.29289 21.7071C5.48043 21.8946 5.73478 22 6 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V9H15C13.3431 9 12 7.65685 12 6V2H6ZM18.5858 7L14 2.41421V6C14 6.55228 14.4477 7 15 7H18.5858Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as ComplianceTeam
};
